import { render, staticRenderFns } from "./recruiterKpiDashboard.vue?vue&type=template&id=21640798&scoped=true"
import script from "./recruiterKpiDashboard.vue?vue&type=script&lang=js"
export * from "./recruiterKpiDashboard.vue?vue&type=script&lang=js"
import style0 from "./recruiterKpiDashboard.vue?vue&type=style&index=0&id=21640798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21640798",
  null
  
)

export default component.exports